"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const store_1 = require("../../../../context/store");
const common_1 = require("../../../../utils/common");
const react_1 = require("react");
const CalendarHeaderCol_1 = __importDefault(require("../calendarHeaderCol/CalendarHeaderCol"));
const CalendarHeaderColText_1 = __importDefault(require("../calendarHeaderColText/CalendarHeaderColText"));
const DateWeekDay_1 = __importDefault(require("../../../dateWeekDay/DateWeekDay"));
/**
 * Get numeric representation of days
 *
 * @param props
 * @constructor
 */
const CalendarHeaderDates = (props) => {
    const [store] = (0, react_1.useContext)(store_1.Context);
    const { width, isMobile, selectedView } = store;
    const { daysNum, calendarDays } = props;
    const colWidth = (0, common_1.getCorrectWidth)(width, isMobile, selectedView) / daysNum;
    const renderNumericDays = () => calendarDays.map((calendarDay) => {
        return ((0, jsx_runtime_1.jsx)(DateWeekDay_1.default, { width: colWidth, day: calendarDay, setViewChanged: props.setViewChanged }, calendarDay.toString()));
    });
    const numericDays = renderNumericDays();
    return ((0, jsx_runtime_1.jsx)(CalendarHeaderCol_1.default, { children: (0, jsx_runtime_1.jsx)(CalendarHeaderColText_1.default, { children: numericDays }) }));
};
exports.default = CalendarHeaderDates;
